import {useAssertedContext} from '@pexip/media-components';

import {CallHistoryContext} from '../contexts/callHistory.context';

export const useCallHistoryContext = () =>
    useAssertedContext(CallHistoryContext);
